<script setup lang="ts">
import { RouteLocationRaw } from 'vue-router';

// Properties
const props = defineProps<{
    text?: string,
    to: RouteLocationRaw | string,
    target?: '_blank' | '_self' | '_parent' | '_top',
    title?: string,
}>();

// Computed
const componentProps = computed(() => (typeof props.to === 'string') ? {href: props.to} : {to: props.to});
</script>

<template>
    <Component
        :is="(typeof to === 'string') ? 'a': 'RouterLink'"
        v-bind="componentProps"
        :target="target"
        :title="title"
        class="text-gray-200 hover:text-gray-50 active:text-gray-50 disabled:text-gray-600"
    >
        <slot>
            {{ text }}
        </slot>
    </Component>
</template>

<style scoped>

</style>
